import { CircularProgress } from '@mui/material';
import React from 'react';

const DEFAULT_SIZE = 40;

interface SpinnerProps {
    size?: number;
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = props => {
    return (
        <CircularProgress
            className={props.className}
            style={{
                width: props.size || DEFAULT_SIZE,
                height: props.size || DEFAULT_SIZE,
                color: 'var(--primary)'
            }}
        />
    );
};
